import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { InstalarAppButton } from '../components/InstalarAppButton';

export const HomeScreen = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Admin autenticado nunca deve ver a landing page pública — vai direto para o painel.
  if (user?.tipo === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="min-h-screen bg-white relative">
      <div className="fixed top-4 right-4 z-40">
        <InstalarAppButton variant="header" />
      </div>
      <main>
      {/* Header/Hero Section */}
      <section className="bg-teal-50 py-6 2xl:py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-14 h-14 2xl:w-24 2xl:h-24 bg-brand-500 rounded-full flex items-center justify-center mx-auto mb-3 2xl:mb-8">
            <svg className="w-7 h-7 2xl:w-12 2xl:h-12 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
            </svg>
          </div>
          <h1 className="text-3xl sm:text-4xl 2xl:text-6xl font-bold text-gray-900 mb-2 2xl:mb-6">
            Saúde Connecting
          </h1>
          <p className="text-sm sm:text-base 2xl:text-xl text-gray-600 mb-5 2xl:mb-12 max-w-2xl mx-auto">
            Criando conexões e divulgando oportunidades.
            Conectamos profissionais da saúde com as melhores <span style={{color:'#007373'}}>oportunidades. </span>
            Seu sucesso profissional passa por aqui!
          </p>

          <div className="grid md:grid-cols-2 gap-4 2xl:gap-8 max-w-3xl mx-auto">
            <div className="bg-white p-4 2xl:p-8 rounded-3xl border border-gray-200 hover:shadow-md transition-shadow duration-200">
              <div className="text-center">
                <div className="w-12 h-12 2xl:w-16 2xl:h-16 bg-brand-500 rounded-full flex items-center justify-center mx-auto mb-2 2xl:mb-6">
                  <svg className="w-6 h-6 2xl:w-8 2xl:h-8 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h2 className="text-lg 2xl:text-2xl font-bold text-gray-800 mb-1 2xl:mb-4">Sou Profissional</h2>
                <p className="text-gray-600 text-xs sm:text-sm 2xl:text-base mb-3 2xl:mb-6">
                  Médicos, Enfermeiros, Fonoaudiólogos, Técnicos de Enfermagem e outros profissionais da saúde
                </p>
                <button
                  onClick={() => navigate('/cadastro?type=profissional')}
                  className="w-full py-2.5 px-6 bg-brand-700 hover:bg-brand-800 text-white font-semibold rounded-xl transition-colors text-sm"
                >
                  Buscar Oportunidades
                </button>
              </div>
            </div>

            <div className="bg-white p-4 2xl:p-8 rounded-3xl border border-gray-200 hover:shadow-md transition-shadow duration-200">
              <div className="text-center">
                <div className="w-12 h-12 2xl:w-16 2xl:h-16 bg-brand-500 rounded-full flex items-center justify-center mx-auto mb-2 2xl:mb-6">
                  <svg className="w-6 h-6 2xl:w-8 2xl:h-8 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h2 className="text-lg 2xl:text-2xl font-bold text-gray-800 mb-1 2xl:mb-4">Sou Instituição</h2>
                <p className="text-gray-600 text-xs sm:text-sm 2xl:text-base mb-3 2xl:mb-6">
                  Hospitais, clínicas, UBS e outras instituições de saúde
                </p>
                <button
                  onClick={() => navigate('/cadastro?type=empresa')}
                  className="w-full py-2.5 px-6 bg-brand-700 hover:bg-brand-800 text-white font-semibold rounded-xl transition-colors text-sm"
                >
                  Publicar Oportunidades
                </button>
              </div>
            </div>
          </div>

          <div className="mt-4 2xl:mt-12">
            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
              <button
                onClick={() => navigate('/cadastro')}
                className="px-8 py-2.5 bg-brand-700 hover:bg-brand-800 text-white font-semibold rounded-xl transition-colors text-sm"
              >
                Criar Conta
              </button>
              <div className="text-gray-400 hidden sm:block">ou</div>
              <button
                onClick={() => navigate('/login')}
                className="px-8 py-2.5 border border-brand-700 text-brand-700 hover:bg-brand-700 hover:text-white font-semibold rounded-xl transition-colors text-sm"
              >
                Fazer Login
              </button>
            </div>
            <p className="text-gray-500 mt-2 text-xs sm:text-sm">
              Junte-se a milhares de profissionais e instituições de saúde
            </p>
          </div>
        </div>
      </section>

      {/* Sobre Nós Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Sobre a Saúde Connecting
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nossa missão é conectar profissionais de saúde qualificados com as instituições 
              que mais precisam de seus cuidados e dedicação.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Conexões Verificadas</h3>
              <p className="text-gray-600">
                  Todos os profissionais e instituições são verificados para garantir sua segurança na hora de contratar e/ou oferecer seus serviços
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Processos Rápidos</h3>
              <p className="text-gray-600">
                Plataforma intuitiva que acelera o processo de contratação entre profissionais e instituições.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Foco na Saúde</h3>
              <p className="text-gray-600">
                Especializado exclusivamente na área da saúde, entendemos as necessidades específicas do setor.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-lg border border-teal-100">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4">Nossa História</h3>
                <p className="text-gray-600 mb-4">
                  A Saúde Connecting nasceu da necessidade de profissionalizar e humanizar o processo 
                  de recrutamento na área da saúde. Sabemos que por trás de cada vaga existe uma 
                  oportunidade de salvar vidas e fazer a diferença.
                </p>
                <p className="text-gray-600">
                  Nossa plataforma foi desenvolvida especialmente para atender às particularidades 
                  do setor de saúde, facilitando a conexão entre talentos e oportunidades.
                </p>
              </div>
              <div className="bg-teal-50 rounded-2xl p-8">
                <ul className="space-y-4 text-left">
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-brand-700 shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-gray-700"><strong className="text-gray-900">Feita sob medida para a saúde</strong> — nada de plataforma genérica adaptada às pressas.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-brand-700 shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span className="text-gray-700"><strong className="text-gray-900">Cadastro rápido e sem burocracia</strong> — comece a usar em poucos minutos.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-brand-700 shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 10-4-4 4 4 0 004 4zm6 0a4 4 0 10-4-4" />
                    </svg>
                    <span className="text-gray-700"><strong className="text-gray-900">Conexão direta</strong> — profissional e instituição falam entre si, sem intermediários.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-brand-500 rounded-full flex items-center justify-center mr-3">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold">Saúde Connecting</h3>
              </div>
              <p className="text-gray-300 mb-4 max-w-md">
                Conectando profissionais de saúde com as melhores oportunidades. 
                Sua carreira cuidando de vidas começa aqui.
              </p>
              <p className="text-gray-400 text-sm">
                © 2024 Saúde Connecting. Todos os direitos reservados.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Para Profissionais</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-brand-500 transition-colors">Buscar Vagas</a></li>
                <li><a href="#" className="hover:text-brand-500 transition-colors">Criar Perfil</a></li>
                <li><a href="#" className="hover:text-brand-500 transition-colors">Dicas de Carreira</a></li>
                <li><a href="#" className="hover:text-brand-500 transition-colors">Certificações</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Para Instituições</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-brand-500 transition-colors">Publicar Vagas</a></li>
                <li><a href="#" className="hover:text-brand-500 transition-colors">Encontrar Talentos</a></li>
                <li><a href="#" className="hover:text-brand-500 transition-colors">Planos</a></li>
                <li><a href="#" className="hover:text-brand-500 transition-colors">Suporte</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8">
            <div className="flex justify-center space-x-6 mb-4">
              <a href="#" className="text-gray-400 hover:text-brand-500 transition-colors">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-500 transition-colors">
                <span className="sr-only">Instagram</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.611-3.194-1.559H3.897v2.559h1.35v-2.559h1.008c.746.948 1.897 1.559 3.194 1.559s2.448-.611 3.194-1.559h1.008v2.559h1.35v-2.559h-1.358c-.746.948-1.897 1.559-3.194 1.559z"/>
                </svg>
              </a>
            </div>
            <p className="text-gray-400 text-sm text-center mb-4">
              Contato: contato@saudeconnecting.com.br | (11) 95797-4327
            </p>
            <div className="flex justify-center">
              <a
                href="/privacidade"
                className="text-gray-400 hover:text-brand-500 text-sm transition-colors underline underline-offset-2"
              >
                Política de Privacidade · LGPD
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};